module.exports = __webpack_public_path__ + "static/media/OpenSansSemiBold.ba5cde21.ttf";